<template>
  <footer class="footer-disclaimer">
    <p>
      Magic: The Gathering™ is a trademark of Wizards of the Coast LLC.
      This site is an independent fan project and is not affiliated,
      endorsed, or sponsored by Wizards of the Coast.
      Card data and images provided by Scryfall.com .
    </p>
  </footer>
</template>

<style scoped>
.footer-disclaimer {
  margin-top: auto;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 12px;
  text-align: center;
  font-size: 12px;
  background-color: var(--color-bg-disclaimer);
  color: var(--color-main-info);
}
</style>